import { NTB_DIP_KEY_FEATURES } from 'constants/paths';
import { userNameSubmitted } from 'actionCreators/user';
import { showHideLoader } from 'actionCreators/loader';
import { updateCase } from 'actionCreators/case';

function submitChooseUserName(values) {
  return new Promise((resolve) => {
    // do any additional work after we submit the form here...

    // If we've got this far, no errors occurred while submitting.
    // Therefore, we can resolve() the Promise successfully.
    resolve();
  });
}

function submitChooseUserNameSuccess(result, dispatch, props) {
  const {
    config,
    loanValues,
    formState,
    caseDetails,
    customerInfo,
    newIncome,
    financialCircumstanceValue
  } = props;
  dispatch(userNameSubmitted());
  dispatch(showHideLoader(true));
  dispatch(
    updateCase(
      config,
      loanValues,
      formState,
      caseDetails,
      customerInfo,
      caseDetails.caseId,
      NTB_DIP_KEY_FEATURES,
      false,
      null,
      null,
      newIncome,
      financialCircumstanceValue
    )
  );
}

function submitChooseUserNameFail(result, dispatch, props) {}

export {
  submitChooseUserName as onSubmit,
  submitChooseUserNameSuccess as onSubmitSuccess,
  submitChooseUserNameFail as onSubmitFail
};
